import { Routes, Route } from "react-router-dom";

import { FooterLogoAlt, FooterNavigation } from "constants/footerNavItems";

import { Home } from "pages/Home";
import { Navbar } from "components/Navbar";
import { Footer } from "components/Footer";

export const Unauthenticated = () => {
	return (
		<>
			<Navbar />
			<Routes>
				<Route path='/' element={<Home />} />
			</Routes>
			<Footer
				description='We are seasoned professionals specializing in forensic auditing,
							tax consulting and audit assurance.'
				imgAlt={FooterLogoAlt}
				navigation={FooterNavigation}
			/>
		</>
	);
};
